import styled from 'styled-components';

/* Mixins */
import {
  BoxSizingSelfAndChildren,
  FlexDirectionColumn,
  WebFontHeader4,
  WebFontBody2,
} from 'styles/Mixins';

/* Utils */
import { assignIfDefined } from 'styles/Utils';

export const Wrapper = styled.div<{ alignLeft?: boolean }>`
  ${BoxSizingSelfAndChildren};
  ${FlexDirectionColumn};
  align-items: flex-start;
  ${({ alignLeft }) =>
    alignLeft
      ? 'text-align: left; align-items: flex-start;'
      : 'align-items: center;'}
`;

export const Header = styled.div<{ margin?: string }>`
  ${WebFontHeader4};
  ${assignIfDefined('margin')};
`;

export const BodyText = styled.div`
  ${WebFontBody2};
  line-height: 20px;
  margin: 8px 0;
`;

export const InputWrapper = styled.div`
  margin: 4px 0;
  width: 100%;
`;
